import { useUpdateDeviceMutation } from '@/graphql/types';

export default function (device: {
  id: string;
  name?: string | undefined;
  stationNumber?: string | undefined;
  templateId: string;
  deviceId: string;
}) {
  const mutation = useUpdateDeviceMutation({});

  function call() {
    return mutation.mutate({
      input: {
        id: device.id,
        name: device.name,
        templateId: device.templateId,
        stationNumber: device.stationNumber,
        deviceId: device.deviceId
      }
    });
  }

  return {
    ...mutation,
    call
  };
}
